export const set = `UI_SET`
export const toggleMenu = `UI_TOGGLE_MENU`
export const toggleMenuCaptions = `UI_TOGGLE_MENU_CAPTIONS`
